declare namespace $ {

	export class $mol_icon_arrow_left extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=left.view.tree.d.ts.map